var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_173_4604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7969 0H8.20312C3.67266 0 0 3.67266 0 8.20312V26.7969C0 31.3273 3.67266 35 8.20312 35H26.7969C31.3273 35 35 31.3273 35 26.7969V8.20312C35 3.67266 31.3273 0 26.7969 0Z",
    fill: "url(#paint0_radial_173_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7969 0H8.20312C3.67266 0 0 3.67266 0 8.20312V26.7969C0 31.3273 3.67266 35 8.20312 35H26.7969C31.3273 35 35 31.3273 35 26.7969V8.20312C35 3.67266 31.3273 0 26.7969 0Z",
    fill: "url(#paint1_radial_173_4604)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5012 3.82812C13.7882 3.82812 13.3221 3.84439 11.8639 3.9107C10.4084 3.97742 9.41486 4.20779 8.54561 4.5459C7.64627 4.89508 6.88352 5.36225 6.12363 6.1224C5.36307 6.88242 4.8959 7.64518 4.54563 8.5441C4.20656 9.41363 3.97592 10.4076 3.91043 11.8624C3.84521 13.3208 3.82812 13.787 3.82812 17.5001C3.82812 21.2133 3.84453 21.6779 3.9107 23.1361C3.9777 24.5916 4.20807 25.5851 4.5459 26.4544C4.89535 27.3537 5.36252 28.1165 6.12268 28.8764C6.88242 29.6369 7.64518 30.1052 8.54383 30.4544C9.41377 30.7925 10.4074 31.0229 11.8627 31.0896C13.3211 31.1559 13.7867 31.1721 17.4996 31.1721C21.213 31.1721 21.6776 31.1559 23.1358 31.0896C24.5913 31.0229 25.586 30.7925 26.4559 30.4544C27.3548 30.1052 28.1165 29.6369 28.8761 28.8764C29.6367 28.1165 30.1037 27.3537 30.4541 26.4548C30.7902 25.5851 31.0209 24.5913 31.0893 23.1364C31.1548 21.6781 31.1719 21.2133 31.1719 17.5001C31.1719 13.787 31.1548 13.3211 31.0893 11.8627C31.0209 10.4072 30.7902 9.41377 30.4541 8.54451C30.1037 7.64518 29.6367 6.88242 28.8761 6.1224C28.1157 5.36197 27.3551 4.8948 26.4551 4.54604C25.5835 4.20779 24.5894 3.97729 23.1339 3.9107C21.6755 3.84439 21.2112 3.82812 17.497 3.82812H17.5012ZM16.2747 6.29193C16.6388 6.29139 17.045 6.29193 17.5012 6.29193C21.1518 6.29193 21.5843 6.30506 23.0259 6.37055C24.3589 6.43152 25.0824 6.65424 25.5644 6.84141C26.2024 7.08914 26.6573 7.38541 27.1355 7.86406C27.614 8.34258 27.9102 8.79826 28.1586 9.43633C28.3458 9.91758 28.5688 10.6411 28.6295 11.9741C28.6949 13.4154 28.7092 13.8482 28.7092 17.497C28.7092 21.1457 28.6949 21.5787 28.6295 23.0199C28.5685 24.3529 28.3458 25.0764 28.1586 25.5578C27.9109 26.1959 27.614 26.6502 27.1355 27.1284C26.657 27.6069 26.2027 27.9031 25.5644 28.1509C25.083 28.3389 24.3589 28.5611 23.0259 28.6221C21.5846 28.6876 21.1518 28.7018 17.5012 28.7018C13.8506 28.7018 13.4179 28.6876 11.9767 28.6221C10.6437 28.5605 9.92018 28.3378 9.43783 28.1507C8.7999 27.9028 8.34408 27.6067 7.86557 27.1281C7.38705 26.6496 7.09092 26.195 6.8425 25.5567C6.65533 25.0753 6.43234 24.3518 6.37164 23.0188C6.30615 21.5775 6.29303 21.1446 6.29303 17.4936C6.29303 13.8426 6.30615 13.412 6.37164 11.9707C6.43262 10.6377 6.65533 9.91416 6.8425 9.43223C7.09037 8.79416 7.38705 8.33848 7.8657 7.85996C8.34422 7.38145 8.7999 7.08518 9.43797 6.83689C9.9199 6.64891 10.6437 6.42674 11.9767 6.36549C13.2379 6.30848 13.7267 6.29139 16.2747 6.28852V6.29193ZM24.7993 8.56201C23.8935 8.56201 23.1587 9.29619 23.1587 10.2021C23.1587 11.1079 23.8935 11.8427 24.7993 11.8427C25.705 11.8427 26.4399 11.1079 26.4399 10.2021C26.4399 9.29633 25.705 8.56146 24.7993 8.56146V8.56201ZM17.5012 10.4789C13.6239 10.4789 10.4802 13.6227 10.4802 17.5001C10.4802 21.3776 13.6239 24.5198 17.5012 24.5198C21.3787 24.5198 24.5213 21.3776 24.5213 17.5001C24.5213 13.6228 21.3784 10.4789 17.501 10.4789H17.5012ZM17.5012 12.9428C20.0181 12.9428 22.0586 14.983 22.0586 17.5001C22.0586 20.017 20.0181 22.0575 17.5012 22.0575C14.9842 22.0575 12.944 20.017 12.944 17.5001C12.944 14.983 14.9842 12.9428 17.5012 12.9428Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_173_4604",
    x: -4,
    y: 0,
    width: 43,
    height: 43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_173_4604"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_173_4604",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_173_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.29687 37.6957) rotate(-90) scale(34.6876 32.2622)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_173_4604",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-5.86264 2.52123) rotate(78.681) scale(15.5055 63.9144)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6600FF",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.06efcb038038c775e9ac3bc0afe40db4.svg";
export { ForwardRef as ReactComponent };